import Datetime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'
import { isMoment, Moment } from 'moment'

const YearSelector = ({ value, onChange }) => {
  const change = (moment: Moment) => {
    if (isMoment(moment)) {
      onChange(moment)
    }
  }

  return <Datetime dateFormat="YYYY" value={value} onChange={change} timeFormat={false} closeOnSelect input={false} />
}

export default YearSelector
